module.exports = __webpack_public_path__ + "img/atlassian_logo.eeaaa861.svg";